module.exports = __webpack_public_path__ + "static/media/img-logo-caixa.1155db85.png";